resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
  Load and store mock data for testing purposes
  https://mogofintech.atlassian.net/wiki/spaces/FEP/pages/236453940/MockService
*/
function MockService (configs) {

  this.constructor = function (configs) {
    // Singleton
    window.mogo = window.mogo || {};
    window.mogo.registry = window.mogo.registry || {};
    this.configs = configs ? configs.sort(function (a, b) {
      return b.matchPattern.length - a.matchPattern.length;
    }) : [];
    if (window.mogo.registry.MockService == null) {
      window.mogo.registry.MockService = this;
      this._initialize();
      return this;
    } else if (this.configs.length) {
      window.mogo.registry.MockService.configs = this.configs;
    }
    return window.mogo.registry.MockService;
  };

  this._initialize = function () {
    this._ROOT_PATH = mogo.registry.mogoUI.config.resourcePaths.rootPath != null ?
      mogo.registry.mogoUI.config.resourcePaths.rootPath + '/mocks/' : '/mocks/';

    window.mogo.registry.mogoUI.config.mockService = window.mogo.registry.mogoUI.config.mockService || {};
    this.mockServiceRuntime = window.mogo.registry.mogoUI.config.mockService;
    this.mockServiceRuntime.capture = this.mockServiceRuntime.capture || null;
    this.mockServiceRuntime.run = this.mockServiceRuntime.run || null;
    this.uiMockStore = new LocalStore('UIMOCK_STORE');

    // Capture initialization
    if (!this.uiMockStore.store.captureProfiles) {
      this.uiMockStore.store.captureProfiles = {};
    }

    if (this.uiMockStore.store.capture) {
      window.ms = this;
      if (!this.mockServiceRuntime.capture) {
        this._startCapture(this.uiMockStore.store.capture);
      } else {
        this.activeProfile = this.uiMockStore.store.captureProfiles[this.uiMockStore.store.capture];
      }
    }

    // Run initialization
    if (this.uiMockStore.store.run) {
      window.ms = this;
      if (!this.mockServiceRuntime.run) {
        this._startProfile(this.uiMockStore.store.run);
      } else {
        this.activeProfile = this.uiMockStore.store.captureProfiles[this.uiMockStore.store.run];
      }
    }
  };

  this.ifPatternMatch = function (url, type) {
    for (let i = 0; i < this.configs.length; i++) {
      if (
        url.match(this.configs[i].matchPattern) &&
        type &&
        this.configs[i].type &&
        type.toLowerCase() === this.configs[i].type.toLowerCase()
    ) {
        return true;
      }
    }
    if (this.mockServiceRuntime.run && this.activeProfile) {
      if (this.activeProfile[type.toUpperCase() + '_' + url]) {
        return true;
      }
    }
    return false;
  };

  this.hasMockData = function (url, type) {
    if (this.mockServiceRuntime.run && this.activeProfile) {
      if (this.activeProfile[type.toUpperCase() + '_' + url]) {
        return true;
      }
    }
    return false;
  };

  this.hasUpdateProperties = function (url, type) {
    for (let i = 0; i < this.configs.length; i++) {
      if (url.match(this.configs[i].matchPattern) &&
        type &&
        this.configs[i].type &&
        type.toLowerCase() === this.configs[i].type.toLowerCase() &&
        this.configs[i].updateProperties
      ) {
        return true;
      }
    }
    return false;
  };

  this.getMockFilePath = function (url, type) {
    for (let i = 0; i < this.configs.length; i++) {
      if (
        url.match(this.configs[i].matchPattern) &&
        type &&
        this.configs[i].type &&
        type.toLowerCase() === this.configs[i].type.toLowerCase() &&
        this.configs[i].mockFileName
      ) {
        return this._ROOT_PATH + this.configs[i].mockFileName;
      }
    }
    return null;
  };

  this.getMockData = function (url, type) {
    if (this.mockServiceRuntime.run && this.activeProfile) {
      if (this.activeProfile[type.toUpperCase() + '_' + url] && this.activeProfile[type.toUpperCase() + '_' + url].data) {
        return JSON.parse(this.activeProfile[type.toUpperCase() + '_' + url].data);
      }
    }
    return null;
  };

  this.updateMockResponse = function (url, type, response) {
    for (let i = 0; i < this.configs.length; i++) {
      if (
        url.match(this.configs[i].matchPattern) &&
        type &&
        this.configs[i].type &&
        type.toLowerCase() === this.configs[i].type.toLowerCase() &&
        this.configs[i].updateProperties
      ) {
        return this._mergeObjects(response, this.configs[i].updateProperties);
      }
    }
    return response;
  };

  // Capture Requests to local storage mode
  this.initCapture = function (name) {
    if (mogo.registry.mogoUI.repo.Portal.presenter.featureControls.isEnabled('disable_mock_services')) {
      console.log('MockService: MockService Feature Control is not enabled.');
      return;
    }

    if (this.mockServiceRuntime.capture) {
      this.stopCapture();
    }
    if (this.mockServiceRuntime.run) {
      this.stopProfile();
    }

    if (this.uiMockStore.store.capture !== name) {
      this.uiMockStore.store.capture = name;
    }

    if (!this.uiMockStore.store.captureProfiles[name]) {
      this.uiMockStore.store.captureProfiles[name] = {};
    }
    this.uiMockStore.save();
    console.log('MockService: Capture mode initialized. Refresh Browser to start.');
  };

  this._startCapture = function (name) {
    if (!mogo.registry.mogoUI.config.mockServiceConfigs) {
      console.error('MockService: Cannot start capture, MockService has not been started.');
      return;
    }

    this.mockServiceRuntime.capture = name;
    this.activeProfile = this.uiMockStore.store.captureProfiles[name];

    $(document).on('ajaxComplete.mockservice', this._onAjaxComplete.bind(this));
    console.log('MockService: Capturing requests under the profile ' + this.mockServiceRuntime.capture + ' has been started...call stopCapture(\'' + this.mockServiceRuntime.capture + '\') to stop.');
  };

  this.stopCapture = function () {
    if (!this.mockServiceRuntime.capture) {
      console.error('MockService: No existing capture is in progress.');
      return;
    }

    const name = this.mockServiceRuntime.capture;
    this.mockServiceRuntime.capture = null;
    delete this.uiMockStore.store.capture;
    this.uiMockStore.save();
    $(document).off('ajaxComplete.mockservice');
    this.activeProfile = null;
    console.log('MockService: Capturing requests under the profile ' + name + ' has been stopped.');
  };

  this.deleteProfile = function (name) {
    if (!this.uiMockStore.store.captureProfiles[name]) {
      console.error('MockService: Cannot delete profile. The specified profile could not be found.');
      return;
    }
    if (name === this.mockServiceRuntime.capture) {
      this.stopCapture();
    }
    if (name === this.mockServiceRuntime.run) {
      this.stopProfile();
    }

    if (this.uiMockStore.store.captureProfiles && this.uiMockStore.store.captureProfiles[name]) {
      delete this.uiMockStore.store.captureProfiles[name];
      this.uiMockStore.save();
      console.log('MockService: The profile ' + name + ' has been deleted.');
      return;
    }

    console.error('MockService: No existing capture under the profile ' + name + '.');
  };

  // Load requests from previously captured data
  this.initProfile = function (name) {
    if (mogo.registry.mogoUI.repo.Portal.presenter.featureControls.isEnabled('disable_mock_services')) {
      console.log('MockService: MockService Feature Control is not enabled.');
      return;
    }

    if (!this.uiMockStore.store.captureProfiles[name]) {
      console.error('MockService: Cannot start profile. The specified profile could not be found.');
      return;
    }
    if (this.mockServiceRuntime.run) {
      this.stopProfile();
    }
    if (this.mockServiceRuntime.capture) {
      this.stopCapture();
    }

    if (this.uiMockStore.store.run !== name) {
      this.uiMockStore.store.run = name;
    }
    this.uiMockStore.save();
    console.log('MockService: Profile mode initialized. Refresh Browser to start.');
  };

  this._startProfile = function (name) {
    if (!mogo.registry.mogoUI.config.mockServiceConfigs) {
      console.error('MockService: Cannot start profile, MockService has not been started.');
      return;
    }

    this.mockServiceRuntime.run = name; // Checked by APIRequest.js

    this.activeProfile = this.uiMockStore.store.captureProfiles[name];
    console.log('MockService: The profile ' + name + ' has been started.');
  };

  this.stopProfile = function () {
    if (!this.mockServiceRuntime.run) {
      console.error('MockService: No profile is currently running.');
      return;
    }

    const name = this.mockServiceRuntime.run;
    this.mockServiceRuntime.run = null;
    delete this.uiMockStore.store.run;
    this.uiMockStore.save();
    this.activeProfile = null;
    console.log('MockService: The profile ' + name + ' has been stopped.');
  };

  this.listProfiles = function () {
    if (this.uiMockStore.store.captureProfiles) {
      for (let key in this.uiMockStore.store.captureProfiles) {
        console.log(key);
      }
    }
  };

  this.exportProfile = function (name) {
    if (!this.uiMockStore.store.captureProfiles[name]) {
      console.error('MockService: Cannot export profile. The specified profile could not be found.');
      return;
    }

    let profileResult = {};
    profileResult[name] = this.uiMockStore.store.captureProfiles[name];
    console.log(JSON.stringify(profileResult));
    console.log('MockService: The profile ' + name + ' was exported successfully.');
  };

  this.importProfile = function (profileObj) {
    for (let key in profileObj) {
      if (this.uiMockStore.store.captureProfiles[key]) {
        console.error('MockService: Cannot import profile. The profile ' + key + ' already exists.');
        return;
      }
      this.uiMockStore.store.captureProfiles[key] = profileObj[key];
      this.uiMockStore.save();
      console.log('MockService: The profile ' + key + ' was imported successfully.');
    }
  };

  this._onAjaxComplete = function (evt, data, req) {
    if (!req.headers || req.headers.Accept !== window.mogo.registry.mogoUI.config.apiAcceptHeader) {
      return;
    }

    if (data && data.responseJSON && data.responseJSON.polling_url) {
      if (!this.activeProfile[data.responseJSON.polling_url]) {
        this.activeProfile[data.responseJSON.polling_url] = {
          url: this._removeUrlParameter(req.url, '_'),
          type: req.type
        };
        this.uiMockStore.save();
      }
    } else {
      let normalizedUrl = this._removeUrlParameter(req.url, '_');
      if (this.activeProfile[normalizedUrl]) {
        let newRecord = {
          matchPattern: this.activeProfile[normalizedUrl]['url'],
          type: this.activeProfile[normalizedUrl]['type'].toLowerCase(),
          data: data.responseText
        };
        this.activeProfile[this.activeProfile[normalizedUrl]['type'] + '_' + this.activeProfile[normalizedUrl]['url']] = newRecord;
        delete this.activeProfile[normalizedUrl];
        this.uiMockStore.save();
      } else {
        console.warn('cannot find url: ' + normalizedUrl);
      }
    }
  };

  this._isObject = function (item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  };

  this._mergeObjects = function (obj1, obj2) {
    let mergedObj = Object.assign({}, obj1);
    if (this._isObject(obj1) && this._isObject(obj2)) {
      Object.keys(obj2).forEach(function (key) {
        let targetObj;
        if (this._isObject(obj2[key])) {
          if (!(key in obj1)) {
            targetObj = {};
            targetObj[key] = obj2[key];
            Object.assign(mergedObj, targetObj);
          } else {
            mergedObj[key] = this._mergeObjects(obj1[key], obj2[key]);
          }
        } else {
          targetObj = {};
          targetObj[key] = obj2[key];
          Object.assign(mergedObj, targetObj);
        }
      }.bind(this));
    }
    return mergedObj;
  };

  this._removeUrlParameter = function (url, parameter) {
    let urlparts = url.split('?');
    if (urlparts.length >= 2) {

      let prefix = encodeURIComponent(parameter) + '=';
      let pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (let i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
  };

  return this.constructor(configs);
}